import { render, staticRenderFns } from "./BaseSecondaryButton.vue?vue&type=template&id=42bae0da&scoped=true&"
import script from "./BaseSecondaryButton.vue?vue&type=script&lang=js&"
export * from "./BaseSecondaryButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseSecondaryButton.vue?vue&type=style&index=0&id=42bae0da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bae0da",
  null
  
)

export default component.exports